import React from 'react';

import { MobileFilter2 } from '../../../filter/MobileFilter2';
import { WallsTypeFilter } from '../../../../models/Filter';
import { DesktopWallsButtonFilterView } from '../../desktop/walls/DesktopWallsButtonFilterView';

interface IWallsFilter {
    filter: WallsTypeFilter;
    handleChange: (value: WallsTypeFilter) => void;
    classNameGroup?: string;
}

export const MobileWallsFilterButtonsView: React.FC<IWallsFilter> = ({
    filter,
    handleChange,
    classNameGroup
}) => {
    return (
        <MobileFilter2 filterTitle='Материал стен'>
            <DesktopWallsButtonFilterView
                filter={filter}
                handleChange={handleChange}
                classNameGroup={classNameGroup}
            />
        </MobileFilter2>
    );
};
